import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  CUSTOM_BUTTON_COLOR,
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';
import { isToolSupportSectionHeader, isToolSupportSectionStyle } from 'src/data/generationTool';

import { ACTION } from '../../const';

import { useStyles } from './useStyles';

const INSTRUCTION = {
  sectionHeader: { text: 'Add section header' },
  h1: { text: 'Use H1 styling for this section' },
  h2: { text: 'Use H2 styling for this section' },
  h3: { text: 'Use H3 styling for this section' },
};

const HEADER_STYLES = [INSTRUCTION.h1, INSTRUCTION.h2, INSTRUCTION.h3];

const getToolInstructions = (generationTool) => {
  if (!isToolSupportSectionStyle(generationTool)) {
    return [];
  }

  const instructions = isToolSupportSectionHeader(generationTool)
    ? [INSTRUCTION.sectionHeader, ...HEADER_STYLES]
    : [...HEADER_STYLES];

  return instructions;
};

export const FooterInstructions = ({ className, onAction, generationTool }) => {
  const styles = useStyles();

  const handleInsertInstruction = useCallback(
    (instruction) => {
      onAction(ACTION.insertInstruction, { instruction });
    },
    [onAction]
  );

  const instructions = getToolInstructions(generationTool);

  if (!instructions.length) {
    return;
  }

  return (
    <div className={cx(className, styles.root)}>
      {instructions.map((instruction) => (
        <CustomButton
          key={instruction.text}
          className={styles.button}
          variant={CUSTOM_BUTTON_VARIANT.contained}
          size={CUSTOM_BUTTON_SIZE.smaller}
          color={CUSTOM_BUTTON_COLOR.silver}
          onClick={() => handleInsertInstruction(instruction)}
        >
          {instruction.text}
        </CustomButton>
      ))}
    </div>
  );
};

FooterInstructions.propTypes = {
  className: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  generationTool: PropTypes.string,
};
FooterInstructions.defaultProps = {
  className: null,
  generationTool: null,
};
